import { render, staticRenderFns } from "./Rules.vue?vue&type=template&id=07e9a4fd&"
import script from "./Rules.js?vue&type=script&lang=js&"
export * from "./Rules.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports